<template>
  <section class="main-menu-footer">
    <div
      class="main-menu-footer-lang"
      @click.prevent="showSwitchLocaleContent = !showSwitchLocaleContent"
    >
      <div class="main-menu-footer-lang-btn-switch-locale">
        <i class="mc-lang"></i>
        <span>{{ $t('component.mainMenuSlideModal.language') }}</span>
      </div>
      <div
        :class="{ active: showSwitchLocaleContent }"
        class="main-menu-footer-lang-btn-switch-locale-block"
      >
        <span
          v-for="localeItem in locales"
          :key="localeItem"
          class="main-menu-footer-lang-btn-switch-locale-text"
          :class="{ active: showSwitchLocaleContent }"
          @click.prevent="switchLocale(localeItem)"
        >
          {{ $t(`locales.${localeItem}`) }}
        </span>
      </div>
    </div>
    <button
      v-if="user"
      class="main-menu-footer-btn"
      data-bs-dismiss="modal"
      @click.prevent="logout"
    >
      <i class="mc-sign-out"></i>
      <span>{{ $t('component.mainMenuSlideModal.logOut') }}</span>
    </button>
    <button
      v-else
      class="main-menu-footer-btn"
      data-bs-dismiss="modal"
      @click.prevent="linkToOpenAuthModal('login')"
    >
      <i class="mc-sign-in"></i>
      <span>{{ $t('component.mainMenuSlideModal.logIn') }}</span>
    </button>
  </section>
</template>
<script>
import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import useComp from '../../../composables/useComp'
import useLocale from '../../../composables/useLocale'
import useLogout from '../../../composables/useLogout'
import useUser from '../../../composables/useUser'
import useAuthModal from '../../../composables/useAuthModal'

export default defineComponent({
  name: 'MainMenuFooter',
  props: {
    name: {
      type: String,
      default: 'MainMenuFooter'
    }
  },
  setup(props, context) {
    const showSwitchLocaleContent = ref(false)
    const { user } = useUser(context)
    const { logout } = useLogout(context)
    const { locale, locales, switchLocale } = useLocale()
    const { compMainMenuSocialMediaList } = useComp()
    const { linkToOpenAuthModal } = useAuthModal(context)

    const templateId = computed(() => process.env.TEMPLATE_ID)

    return {
      user,
      templateId,
      locale,
      locales,
      compMainMenuSocialMediaList,
      showSwitchLocaleContent,
      logout,
      switchLocale,
      linkToOpenAuthModal
    }
  }
})
</script>
